import React from 'react';

import { Radio as MuiRadio } from '@material-ui/core';

const Radio = ({ ...props }) =>  <MuiRadio {...props}/>

export default Radio;



// WEBPACK FOOTER //
// ./src/components/base/Radio/Radio.js